import { dBtoVV, VVtoDB } from '../utils/conversion';

export function changeGainUnits(gain: number, gainUnit: string): number {
  let result: number;
  if (gainUnit === 'dB') {
    result = VVtoDB(gain);
  } else {
    result = dBtoVV(gain);
  }

  return result;
}
